"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvidenceSchema = exports.AnnotatedFileRegionEvidenceSchema = exports.BoundingBoxSchema = exports.ImageEvidenceSchema = exports.BaseEvidenceSchema = exports.EvidenceTypeSchema = exports.EvidenceType = void 0;
const zod_1 = require("zod");
const BoundingBox_1 = require("../../Common/BoundingBox");
var EvidenceType;
(function (EvidenceType) {
    EvidenceType["Image"] = "ImageEvidence";
    EvidenceType["AnnotatedFileRegion"] = "AnnotatedFileRegionEvidence";
})(EvidenceType || (exports.EvidenceType = EvidenceType = {}));
exports.EvidenceTypeSchema = zod_1.z.nativeEnum(EvidenceType);
exports.BaseEvidenceSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: exports.EvidenceTypeSchema,
    description: zod_1.z.string(),
});
exports.ImageEvidenceSchema = exports.BaseEvidenceSchema.extend({
    type: zod_1.z.literal(EvidenceType.Image),
    image: zod_1.z.string().optional(),
});
exports.BoundingBoxSchema = BoundingBox_1.boundingBoxSchema;
exports.AnnotatedFileRegionEvidenceSchema = exports.BaseEvidenceSchema.extend({
    type: zod_1.z.literal(EvidenceType.AnnotatedFileRegion),
    fileId: zod_1.z.string().optional(),
    pageNumber: zod_1.z.number().optional(),
    annotations: exports.BoundingBoxSchema.array(),
    region: exports.BoundingBoxSchema.optional(),
});
exports.EvidenceSchema = zod_1.z.discriminatedUnion('type', [
    exports.ImageEvidenceSchema,
    exports.AnnotatedFileRegionEvidenceSchema,
]);
//# sourceMappingURL=Evidence.js.map